import React from "react";
import CareerOpportunity from "../../../components/careerOpportunity";
import FeatureCard from "../../../components/featuredCard";
import HeaderSection from "../../../components/headerSection";
import ImageTextCard from "../../../components/imageTextCard";
import careerImage from "../../../images/icons/image.png";
import Footer from "../home/footer";
function Jobs() {
  const card = [
    {
      title: "Creative Professionals",
      image: "/job1.png",
      description:
        "Creativity is an inherently human trait that AI struggles to mimic. While AI can generate ar...",
    },
    {
      title: "Cybersecurity Experts",
      image: "/job2.png",
      description:
        "As technology advances, so do threats in the cyber world. Cybersecurity professionals are...",
    },
    {
      title: "AI and Robotics Engineers",
      image: "/job3.png",
      description:
        "Paradoxically, the field creating AI and automation is also one of the most future-pr...",
    },
  ];
  return (
    <div>
      <HeaderSection
        title="Jobs"
        description="Explore AI-Resilient Jobs of the Future Discover roles that thrive in the AI-driven economy and find your path to a secure, innovative career"
        descriptionClass="text-center w-[696px]"
      />
      <ImageTextCard
        image={careerImage}
        position="left"
        imageClass="w-[640px] h-auto"
        label="Explore Careers Built for the Future"
        subTitle="While AI is reshaping the job market, many roles are poised not just to survive but to thrive. Our Popular AI-Resilient Jobs section highlights careers that leverage uniquely human skills less susceptible to automation"
      />
      <FeatureCard
        label="Feature Courses"
        description="Enhance your career with expertly designed courses tailored for the AI-driven landscape, equipping you with critical skills and insights to stay ahead and thrive."
        cards={card}
      />
      <CareerOpportunity />
      <Footer />
    </div>
  );
}

export default Jobs;
